import { config } from '../config';

const AUTH_DATA_KEY = 'authData';

export default {
	login,
	logout,
	get,
	post,
	downloadFile,
	loadScript,
	getEuSignSignature,
	AUTH_DATA_KEY
};

async function login(resourse, userName, password, signature) {
	const url = new URL(`${config.apiUrl}/${resourse}`);

	const parameters = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ userName, password, signature })
	};

	try {
		const response = await fetch(url, parameters);
		const authData = await handleResponse(response);

		if (authData.isSuccess) {
			logout();
			localStorage.setItem(AUTH_DATA_KEY, JSON.stringify(authData.data));
		}

		return authData;
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function logout(resourse) {
	const url = new URL(`${config.apiUrl}/${resourse}`);

	const headers = setHeaders();

	const parameters = {
		method: 'POST',
		headers: headers,
		body: {}
	};

	try {
		await fetch(url, parameters);
		localStorage.removeItem(AUTH_DATA_KEY);
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function get(resourse, options) {
	const url = new URL(`${config.apiUrl}/${resourse}`);

	if (options) {
		for (let i = 0; i < options.length; i++) {
			url.searchParams.append(options[i].name, encodeURI(options[i].value));
		}
	}

	const headers = setHeaders();

	if (!headers) {
		logout();
		location.reload(true);

		return;
	}

	const parameters = {
		method: 'GET',
		headers: headers
	};

	try {
		const response = await fetch(url, parameters);
		const data = await handleResponse(response);

		return data;
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function post(resourse, body) {
	const url = new URL(`${config.apiUrl}/${resourse}`);

	const headers = setHeaders();

	if (!headers) {
		logout();
		location.reload(true);

		return;
	}

	const parameters = {
		method: 'POST',
		headers: headers,
		body: JSON.stringify(body)
	};

	try {
		const response = await fetch(url, parameters);
		const data = await handleResponse(response);

		return data;
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function downloadFile(resourse, body, fileName) {
	const url = new URL(`${config.apiUrl}/${resourse}`);

	const headers = setHeaders();

	if (!headers) {
		logout();
		location.reload(true);

		return;
	}

	const parameters = {
		method: 'POST',
		headers: headers,
		body: JSON.stringify(body)
	};

	try {
		const response = await fetch(url, parameters);

		if (response.status === 401) {
			logout();
			location.reload(true);

			return;
		}

		if (response.status !== 200) {
			const text = await response.text();

			const data = JSON.parse(text);

			return {
				isSuccess: false,
				data: data
			};
		}

		const blob = await response.blob();

		const fileURL = window.URL.createObjectURL(blob);

		const fileLink = document.createElement('a');
		fileLink.href = fileURL;
		fileLink.download = fileName;

		document.body.appendChild(fileLink);

		fileLink.click();

		return {
			isSuccess: true
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

function loadScript(src) {
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = src;
		script.onload = resolve;
		script.onerror = reject;
		document.body.appendChild(script);
	});
}

async function getEuSignSignature(userName) {
	const url = new URL(`${config.apiUrl}/${config.eusign.getSignatureUrl}`);

	const parameters = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json' }
	};

	url.searchParams.append("userName", encodeURI(userName));
	url.searchParams.append("hashAlgorithm", 9);

	try {
		const response = await fetch(url, parameters);
		const signature = await response.text();

		return signature;
	} catch (error) {
		console.log(`get signature error: ${error}`)
		return null;
	}
}

function setHeaders() {
	let authData = JSON.parse(localStorage.getItem(AUTH_DATA_KEY));

	if (authData) {
		return {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${authData.accessToken}`
		}
	}

	return null;
}

async function handleResponse(response) {
	const text = await response.text();

	if (response.status === 401) {
		logout();
		location.reload(true);

		return;
	}

	const data = JSON.parse(text);

	return {
		isSuccess: response.status == 200 ? true : false,
		data: data
	};
}